export default class Validator {
    static isNameValid(name) {
        return name.trim().length > 0 && /^[a-zľščťžýáíéňäôúřůĺ ]+$/.test(name.toLowerCase());
    }

    static isEmailValid(email) {
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return email.trim().length > 0 && re.test(String(email).toLowerCase());
    }

    static isPasswordValid(password){
        return password.trim().length > 7 && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(password);
    }
    static isTimeValid(time){
        if (!time) {
            return true;
        }
        return time.toString().trim().length > 0 && parseInt(time.trim()) < 251 && /^[0-9\b]+$/.test(time);
    }

}